import React, { useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, IconButton } from '@material-ui/core';
import ProgressFullscreen from '../common/ProgressFullscreen';
import FileNameConatiner from './FileNameContainer';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(4),
    height: 'calc(100% - 64px)'
  },
  header: {
    backgroundColor: '#fafafa',
    height: 64,
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 16
  },
  headerText: {
    fontSize: '1.25rem',
    fontWeight: 500
  },
  paper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 15,
    backgroundColor: '#fff',
    paddingBottom: 15,
    borderRadius: 4
  },
  uploadContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    marginBottom: '20px'
  }
}));

const FileUpload = ({
  file,
  fileName,
  isUploading,
  onFileChange,
  onFileClear,
  onUpload,
  selectBtnText,
  uploadBtnText,
  acceptFileType,
  inputId
}) => {
  const classes = useStyles();
  const fileInputRef = useRef(null);

  const handleClearFile = () => {
    fileInputRef.current.value = '';
    onFileClear();
  };

  return (
    <div className={classes.container}>
      <ProgressFullscreen open={isUploading} />
      <div className={classes.header}>
        <span className={classes.headerText}>Upload Bom Report</span>
      </div>
      <div className={classes.paper}>
        <div className={classes.uploadContainer}>
          <input
            accept={acceptFileType}
            id={inputId}
            ref={fileInputRef}
            type="file"
            onChange={onFileChange}
            style={{ display: 'none' }}
          />
          <div className={classes.buttonContainer}>
            <label htmlFor={inputId}>
              <Button
                variant="contained"
                component="span"
                color="primary"
                disabled={isUploading || file != null}
              >
                {selectBtnText}
              </Button>
            </label>
            <Button
              variant="contained"
              onClick={onUpload}
              disabled={!file || isUploading}
              color="primary"
            >
              {uploadBtnText}
            </Button>
          </div>
          <FileNameConatiner
            fileName={fileName}
            isUploading={isUploading}
            onClearFile={handleClearFile}
          />
        </div>
      </div>
    </div>
  );
};

export default FileUpload;
